// extracted by mini-css-extract-plugin
module.exports = {"merch__img":"merch_merch__img__5euvn"};